import React, { Component } from 'react';

import {Table, TableBody, TableRow, TableRowColumn} from 'material-ui/Table';
import {Card, CardText} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';

import Config from '../../conf';
import moment from 'moment';

import {Confirm as styles} from './form.css';

import 'whatwg-fetch';

class Confirm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      bookButtonDisabled: false,
      error: false,

      bookingCompleted: false
    };

    this.confirmClicked = this.confirmClicked.bind(this);
    this.sendToBackend = this.sendToBackend.bind(this);
    this.bookButtonClicked = this.bookButtonClicked.bind(this);
    this.retry = this.retry.bind(this);
    this.refreshPage = this.refreshPage.bind(this);
  }

  refreshPage() {
    location.reload();
  }

  bookButtonClicked() {
    this.setState({
      bookButtonDisabled: true
    });
  }

  retry() {
    this.setState({
      bookButtonDisabled: false,
      loading: false,
      error: false
    });
    this.confirmClicked();
  }

  sendToBackend(body) {
    // set to loading mode
    this.setState({
      loading: true
    });
    return new Promise((resolve, reject) => {
      fetch(Config.BACKEND_API_URL + 'carpark/create', {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      }).then(response => {
        return response.json().then(data => {
          if (data.status === 200) {
            resolve();
          } else {
            throw Error('response status from backend was ' + data.status + ' (data = ' + JSON.stringify(data) + ')');
          }
        });
      }).catch(err => {
        reject(err);
      });
    });
  }

  confirmClicked() {
    const body = {
      name: this.props.details.name,
      email: this.props.details.email,
      phone: this.props.details.phone,
      numberPlate: this.props.details.numberPlate,
      address: this.props.details.address,
      carType: this.props.details.carType,
      washType: this.props.details.washType,
      notes: this.props.details.notes,
      platform: 'white',
      whiteLabel: Config.CLIENT_NAME
    };
    this.sendToBackend(body).then(() => {
      this.setState({
        bookingCompleted: true
      });
    }).catch(err => {
      this.setState({
        error: true
      });
      console.log('Failed to send to backend: ' + err);
    });
  };

  render() {
    console.log(this.props.details);

    const prettyStartDate = moment(this.props.details.date).format('dddd Do of MMMM, YYYY');
    const prettyStartTime = moment(`${this.props.details.startTime.hours}:${this.props.details.startTime.mins}`, 'k:m', true).format('h:mm A');
    const prettyEndTime = moment(`${this.props.details.endTime.hours}:${this.props.details.endTime.mins}`, 'k:m', true).format('h:mm A');
    const prettyWashTimeString = `${prettyStartDate} ${prettyStartTime} - ${prettyEndTime}`;

    const rows = [
      { name: 'Full Name', value: this.props.details.name },
      { name: 'Email Address', value: this.props.details.email },
      { name: 'Mobile Number', value: this.props.details.phone },
      { name: 'Number Plate', value: this.props.details.numberPlate },
      { name: 'Wash Type', value: this.props.details.carType + ' ' + this.props.details.washTypeDisplay + ' $' +
          this.props.details.washPrice.toFixed(2) },
      { name: 'Wash Date', value: prettyWashTimeString },
    ];

    return (
      <div>
      {!this.state.error && !this.state.loading && !this.state.bookingCompleted &&
        <Card style={styles.card}>
          <h2 style={styles.title}>
            Confirm
          </h2>

          {this.props.details.isSmallScreen ?
            <div>
            {rows.map((row) => {
              return (
                <p key={row.name}>
                  <strong>{row.name}</strong>:
                  <br />
                  {row.value}
                </p>
              );
            })}
            </div>
          :
            <Table selectable={false} style={styles.table}>
              <TableBody displayRowCheckbox={false}>
              {rows.map((row) => {
                return (
                  <TableRow key={row.name}>
                    <TableRowColumn style={styles.nameCol}>{row.name}</TableRowColumn>
                    <TableRowColumn style={styles.valueCol}>{row.value}</TableRowColumn>
                  </TableRow>
                );
              })}
              </TableBody>
            </Table>
          }

          <RaisedButton style={styles.button}
            label="Back" primary={true} onClick={this.props.back} />
          <RaisedButton
            style={styles.button}
            label="Confirm"
            primary={true}
            onClick={this.confirmClicked}
          />
        </Card>
      }
      {this.state.bookingCompleted &&
        <Card style={styles.card}>
          <h2 style={styles.title}>Finished</h2>
          <CardText>
            <div>
              Thank you, your car wash has been booked! You will shortly receive payment instructions in your email.
            </div>
            <div>
              <RaisedButton
                style={{...styles.button,...{marginTop: 40}}}
                label="Done"
                primary={true}
                onClick={this.refreshPage}
              />
            </div>
          </CardText>
        </Card>
      }
      {!this.state.error && this.state.loading && !this.state.bookingCompleted &&
        <Card style={styles.card}>
          <h2 style={styles.title}>Making your booking...</h2>
          <CardText>
            <CircularProgress />
          </CardText>
        </Card>
      }
      {this.state.error && !this.state.bookingCompleted &&
        <Card style={styles.card}>
          <h2 style={styles.title}>Error</h2>
          <CardText>
            <div>
              An error occurred.
            </div>
            <div>
              <RaisedButton
                style={{...styles.button,...{marginTop: 40}}}
                label="Retry"
                primary={true}
                onClick={this.retry}
              />
            </div>
          </CardText>
        </Card>
      }
      </div>
    );
  }
}

export default Confirm;



// WEBPACK FOOTER //
// ./src/app/components/form/Confirm.js